import React from "react";

function TableItems(props) {
  const { children, ...otherProps } = props;

  return <tbody {...otherProps}>{children}</tbody>;
}

export default TableItems;
